export const selectedChip = {
  backgroundColor: "#295FFF",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer",
  "&:hover": { backgroundColor: "#507CFF", color: "#fff" },
};

export const unselectedChip = {
  backgroundColor: "#fff",
  color: "#64748B",
  fontWeight: "normal",
  cursor: "pointer",
  "&:hover": { backgroundColor: "#507CFF", color: "#fff"},
};

export const outlinedFieldHover = (borderRadius: string) => ({
  "& .MuiOutlinedInput-root": { backgroundColor: "#fff", borderRadius },
  "& .MuiOutlinedInput-root:hover:not(.Mui-focused)": {
    backgroundColor: "#F5F8FF",
  },
  "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
    {
      borderColor: "#003FFB",
      borderWidth: "1px",
    },
  "& .MuiInputLabel-root.Mui-focused": { color: "#003FFB" },
});

export const cardSx = { p: 2, borderRadius: "12px", borderColor: "#E2E8F0" };

export const filterChip = (selected: boolean) => ({
  fontSize: "12px",
  fontWeight: selected ? "bold" : "normal",
  backgroundColor: selected ? "#DBEAFE" : "#F1F3F6",
  color: selected ? "#2563EB" : "#6B7380",
  "&:hover": { backgroundColor: "#DBEAFE", color: "#2563EB" },
});
